'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invert = require('lodash/invert');

var _invert2 = _interopRequireDefault(_invert);

var _illustration = require('lemon-db/dist/options/illustration.json');

var _illustration2 = _interopRequireDefault(_illustration);

var _illustrationNameMap = require('lemon-db/dist/illustrationNameMap.json');

var _illustrationNameMap2 = _interopRequireDefault(_illustrationNameMap);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var invertedMap = (0, _invert2['default'])(_illustrationNameMap2['default']);
var options = exports.options = Object.assign({}, _illustration2['default']);

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      UIIllustration = _ref.UIIllustration;

  var Illustration = function (_React$Component) {
    _inherits(Illustration, _React$Component);

    function Illustration() {
      _classCallCheck(this, Illustration);

      return _possibleConstructorReturn(this, (Illustration.__proto__ || Object.getPrototypeOf(Illustration)).apply(this, arguments));
    }

    _createClass(Illustration, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            theme = _props.theme,
            color = _props.color,
            height = _props.height,
            rest = _objectWithoutProperties(_props, ['theme', 'color', 'height']);

        return _react2['default'].createElement(UIIllustration, _extends({
          height: height,
          className: theme.illustrationWrapper,
          name: this.name,
          componentName: this.componentName,
          color: color
        }, rest));
      }
    }, {
      key: 'name',

      /**
       * returns illustration name no matter what
       * @return {*}
       */
      get: function get() {
        var name = this.props.name; // is already illustration name

        if (_illustrationNameMap2['default'][name]) {
          return name;
        } // is undraw component name
        // but we want illustration name


        if (invertedMap[name]) {
          return invertedMap[name];
        }
      }
      /**
       * returns undraw component name no matter what
       * @return {*}
       */

    }, {
      key: 'componentName',
      get: function get() {
        var name = this.props.name; // is normal illustration name, e.g. blank-canvas
        // but we want component name

        if (_illustrationNameMap2['default'][name]) {
          return _illustrationNameMap2['default'][name];
        } // is already undraw component name


        if (invertedMap[name]) {
          return name;
        }
      }
    }]);

    return Illustration;
  }(_react2['default'].Component);

  Illustration.displayName = identifier;
  Illustration.themeShape = {
    illustrationWrapper: _propTypes2['default'].string.isRequired
  };
  Illustration.propTypes = {
    theme: _propTypes2['default'].shape(Illustration.themeShape).isRequired,
    name: _propTypes2['default'].string,
    height: _propTypes2['default'].number.isRequired,
    color: _propTypes2['default'].string.isRequired
  };
  Illustration.defaultProps = {
    color: 'themeColor'
  };
  return Illustration;
};

exports['default'] = factory;